import { Component, OnInit } from '@angular/core';
import * as ngswal from "sweetalert";
import { FeedbackAPIModel } from './feedback-model';
import { ApiMethod } from '../apimethods/api-method';
import { Router, ActivatedRoute } from '@angular/router';
import { GlobalConstants } from '../common/global-constants';

declare var $;

@Component({
  selector: 'app-feedback-list',
  templateUrl: './feedback-list.component.html',
  styleUrls: ['./feedback-list.component.css']
})
/** FeedbackList component*/
export class FeedbackListComponent implements OnInit {
  modelItem = new FeedbackAPIModel();
  maxValue = 5;
  FeedbackName: any;
  FeedbackTopContent: any;
  FeedbackDesc: any;
  FeednackBottomContent: any;
  artNo: any;
  Journal: any;
  ArticleNo: any;
  AuthorName: any;
  FeedbackRatings: any;

  ngOnInit(): void {
    ApiMethod.getBaseUrl();

    this.route.queryParamMap.subscribe(params => {
      if (params.get("artno") != null) {
        this.artNo = params.get("artno");
      }
      else {
        ngswal("Warning !", 'Invalid URL !', "warning");
      }
    });
    $('.container').css('height', GlobalConstants.size.height);
    /* $('.tblfeedbacklist').css('height', GlobalConstants.size.height - 400);*/

  }

  /** FeedbackList ctor */
  constructor(private router: Router, private route: ActivatedRoute) {
    ApiMethod.getPageConfig().subscribe(
      data => {
        this.modelItem = <FeedbackAPIModel>data["FeedbackPage"];

        this.getfeedbackpage();


      }, error => {
        ngswal("Warning !", error.message, "warning");
      });
  }

  ngAfterViewChecked(): void {
    if ($('.emoji-table').length == 0) {
      $(".emoji-div .rating").each(function (ind) {
        $("#" + $(this)[0].id).emoji();
      });
    }
  }

  // get feedback page details
  getfeedbackpage() {
    if (this.artNo != null) {
      $("#LoadingImage").show();
      ApiMethod.getMethod(this.modelItem.FeedbackDetailsAPI + '/' + this.artNo).subscribe(
        response => {
          var details = response.Feedbacklist;

          this.modelItem.FeedbackNamelist = JSON.parse(JSON.stringify(details));

          //Feedbackpage

          var summerydetails = response._feedbackSumData;
          
          if (details[0].IsAlreadySubmitted == "Yes") {
            this.modelItem.FeedbackNamelist = JSON.parse(JSON.stringify(summerydetails));
            this.modelItem.TopBannerImage = details[0].TopBannerImage;
            this.modelItem.FeedbackTitle = details[0].FeedbackTitle;
            this.modelItem.FeedbackTopContent = details[0].FeedbackTopContent;
            this.modelItem.FeedbackDesc = summerydetails[0].Remarks;
            this.modelItem.FeednackBottomContent = details[0].FeednackBottomContent;
            $("#LoadingImage").hide();
            $("#btnsave").hide();
            $('#txtFeedbackDesc').attr('disabled', 'disabled');


          } else {
            this.modelItem.TopBannerImage = details[0].TopBannerImage;
            this.modelItem.FeedbackTitle = details[0].FeedbackTitle;
            this.modelItem.FeedbackTopContent = details[0].FeedbackTopContent;
            //table
            this.modelItem.FeedbackNamelist = JSON.parse(JSON.stringify(details));
            this.modelItem.FeednackBottomContent = details[0].FeednackBottomContent;

            $("#LoadingImage").hide();

          }

        }, error => {
        $("#LoadingImage").hide();
        ngswal("Failed !", error.message, "warning");
      });
    }
  }

  //save feedback details
  savefeedbackinfo() {
    $("#LoadingImage").show();
    var getFeedbacklist = GlobalConstants.GetTableRowToList('tblfeedbacklist', null);
    var feedbackdate = {
      Remarks: $("#txtFeedbackDesc").val(),
      ArticleNo: this.artNo,
      Feedbacklist: JSON.stringify(getFeedbacklist)
    };
    ApiMethod.postMethod(this.modelItem.SaveFeedbackInfo, feedbackdate).subscribe(
      resonse => {
        $("#LoadingImage").hide();
        ngswal({
          position: "top-end",
          type: "success",
          title: " Thanks for submiting Feedback  !",
          text: resonse,
          showConfirmButton: false,
          timer: 1500
        });
        this.getfeedbackpage();
      }, error => {
        ngswal("Failed !", error.error.Message, "warning");
        $("#LoadingImagePopup").hide();
      }
    );

  }
}


















